import { useDiscountWizardStateContext } from '../state';
import { RequirementsStepActions } from '../state/requirements';
import { RewardsStepActions } from '../state/rewards';

import type { FilterResourceType } from './filter';

export function useConditionalFilterParameters(requirement: number | 'reward') {
  const { requirementsStepState, requirementsStepDispatch, rewardsStepState, rewardsStepDispatch } =
    useDiscountWizardStateContext();

  if (requirement === 'reward') {
    const { filters } = rewardsStepState.condition;
    return {
      description: 'Customers can receive the discount on products in this list.',
      filterButtonClickHandler: (val: FilterResourceType) =>
        rewardsStepDispatch({
          type: RewardsStepActions.SET_ACTIVE_FILTER,
          payload: val,
        }),
      filters,
      heading: 'Reward products',
      noFilterWarningFragment: 'can receive the discount',
    };
  }
  return {
    description: 'Customers must purchase products from this list to satisfy the requirement.',
    filterButtonClickHandler: (val: FilterResourceType) =>
      requirementsStepDispatch({
        type: RequirementsStepActions.SET_ACTIVE_FILTER,
        payload: {
          filter: val,
          requirement,
        },
      }),
    filters: requirementsStepState[requirement].filters,
    heading: 'Qualifying products',
    noFilterWarningFragment: 'will be a qualifying product',
  };
}
